
import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';

const NavIcon = ({ items }) => {
    let navIcons = false;
    if (items.icon) {
        // Si el icono ya viene con 'bi bi-' lo usamos tal cual, si no lo añadimos
        const iconClass = items.icon.startsWith('bi') ? items.icon : `bi bi-${items.icon}`;
        navIcons = (
            <span className="pcoded-micon">
                <i className={iconClass} />
            </span>
        );
    }

    return <React.Fragment>{navIcons}</React.Fragment>;
};

export default NavIcon;
